module.exports = __webpack_public_path__ + "static/media/fechar-menu-mobile_custom.4b84f75d.svg";